import React, { Fragment, useEffect, useState } from 'react';
import UserInfo from './AccountPanels/UserInfo';
import TabMenu from './Common/TabMenu';
import Topic from './ManagerPanels/Topic';
import UserInfoAcc from './AccountPanels/UserInfoAcc';
import MyBookmarks from './AccountPanels/MyBookmarks';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AuthConfirm from './AccountPanels/AuthConfirm';
import { showToast } from './Common/Messages';

const Account = () => {
    const LoginStates = useSelector(state => state.login);
    const companySeq = LoginStates?.companySeq;
    const location = useLocation();
    const history = useNavigate();

    const [tabInfo, setTabInfo] = useState({
        current: '',
        menu: [
            { id: "myBookmarks", title: "즐겨찾기한 매뉴얼", type: "star" },
            { id: "userInfo", title: "비밀번호 변경", type: "tab" },
            { id: "topicList", title: "1:1문의", type: "tab" },
            { id: "userInfoAcc", title: "개발권한", type: "tab" },
        ],
        showPopup: false,
        isUseAuth: 0,
        checkReq: false,
    });
    const [tabContent, setTabContent] = useState();
    const [myMenuButtons, setMyMenuButtons] = useState([]);

    useEffect(() => {
        setTabInfo(prev => {
            return {
                ...prev,
                current: location.pathname?.split('/').slice(-1)[0]
            }
        });
        checkUserRole();
        setMyMenuButtons(myMenu())
    }, [LoginStates]);

    useEffect(() => {
        if (LoginStates.userId !== '') {
            const content = loadTabContent(LoginStates.userId);
            setMyMenuButtons(myMenu())
            setTabContent(content);
        }
    }, [tabInfo]);

    const myMenu = () => {
        return (
            <div className="myinfo-tab-wrap">
                {tabInfo.menu.map((x, i) => {
                    return (
                        <button key={i} className={`myinfo-tab ${(location.state?.current ?? tabInfo.current) === x.id ? "selected" : ""}`} onClick={() => hadleCurrentPopup(x.id)}>
                            {x.type === 'star' ? <i className='icoKdc24 star'></i> : null}
                            {x.title}
                        </button>)
                })}
            </div>
        );
    }
    const hadleCurrentPopup = (mode) => {
        history(`/MyPage/${mode}`);
        setTabInfo(prev => {
            return {
                ...prev,
                current: mode
            }
        });
    };

    //사용자 역할 체크하여 메뉴 표시
    const checkUserRole = () => {
        let role = LoginStates?.userRole;
        let arrRole = role?.split(",");
        if (arrRole.includes("GroupAdmin") || arrRole.includes("DevUserAdmin")) {
            setTabInfo(prev => {
                const isAuthConfirmExists = prev.menu.some(item => item.id === "authConfirm");
                if (!isAuthConfirmExists) {
                    return {
                        ...prev,
                        menu: [
                            ...prev.menu,
                            {
                                id: "authConfirm",
                                title: "권한신청관리",
                                type: "tab"
                            }
                        ]
                    };
                }
                return prev;
            });
        }
    };

    //권한 신청 팝업
    const handleRequestPopup = (flag) => {
        setTabInfo(prev => { return { ...prev, showPopup: flag } });
    };

    const loadTabContent = (userId) => {
        let current;

        if (location.state?.locationFrom) {
            current = location.state?.locationCurrent;
        } else if (location.state?.current !== undefined) {
            current = location.state?.current;
        } else {
            current = tabInfo.current;
        }

        if (tabInfo.current.toString().toLowerCase() === 'authconfirm')
            return (
                <AuthConfirm />
            );
        else if (tabInfo.current.toString().toLowerCase() === 'userinfoacc')
            return (
                <UserInfoAcc isUseAuth={tabInfo.isUseAuth} />
            );
        else if (tabInfo.current.toString().toLowerCase() === 'topiclist')
            return (
                <Topic ClickMenu={hadleCurrentPopup} current={current} isAdmin={false} nodePath={location.state?.nodePath} catagoryName={location.state?.catagoryName} locationFrom={location.state?.locationFrom} fullPath={location.state?.fullPath} title={location.state?.title} linkPath={location.state?.linkPath} />
            );
        else if (tabInfo.current.toString().toLowerCase() === 'mybookmarks')
            return (
                <MyBookmarks userId={userId} />
            );
        else
            return (
                <UserInfo />
            );
    };
    return (
        <div className="container">
            <div className="contents-wrapper">
                <div className="contents-wrapper-width">
                    <div className="myinfo">
                        <h2 className='myinfo-title'>마이페이지</h2>
                        <section className="myinfo-wrap">
                            <div className="user-info">
                                <div className="int-ico">
                                    <span>{LoginStates.userId.substring(0, 1).toUpperCase()}</span>
                                </div>
                                <div className="info-wrap">
                                    <p className="name">{LoginStates.userName}</p>
                                    <p className="email">{LoginStates.userId}</p>
                                    <div className="affl">
                                        <div className="affl-wrap">
                                            <p className="affl-cate">회사</p>
                                            <p className="affl-cnts">{LoginStates.companyName}</p>
                                        </div>
                                        {LoginStates.companySeq === '128' ? (
                                            <div className="affl-wrap">
                                                <p className="affl-cate">소속</p>
                                                <p className="affl-cnts">{LoginStates.deptName}</p>
                                            </div>
                                        ) : null}
                                        <div className="affl-wrap">
                                            <p className="affl-cate">직무</p>
                                            <p className="affl-cnts">{LoginStates.kindName}</p>
                                        </div>
                                    </div>
                                </div>
                                {myMenuButtons}
                            </div>
                            {tabContent}
                        </section>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Account;